/** Пояснение «Сайта и контента» без вопросов: тариф ниже или раздел выключен. */
import { VoiceQuestionsUpgrade, VoiceSitePending } from './VoiceSitePending';

export function VoiceSiteClosedNotice({
  reason,
  withThemes,
  upgradeHref,
}: {
  reason: 'off' | 'upgrade';
  withThemes: boolean;
  upgradeHref?: string;
}) {
  return reason === 'upgrade' ? (
    <VoiceQuestionsUpgrade upgradeHref={upgradeHref} />
  ) : (
    <VoiceSitePending withThemes={withThemes} />
  );
}
